import {
  HouseIcon,
  PaperAndPencilIcon,
  ReceiptIcon,
  StarIcon,
} from "@components/icons";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { type IPlanListItem } from "@utils/plans/types";

export const DEFAULT_PLAN_DISCOUNT_DURATION = 3;

export const plansMetadata: Record<PlanId, IPlanListItem> = {
  [PlanId.FRE]: {
    name: "plan.plansMetadata.fre.name",
    subtitle: "plan.plansMetadata.fre.subtitle",
    featureKey: "plan.plansMetadata.fre.featureList",
    badgeProps: {
      icon: PaperAndPencilIcon,
    },
  },
  [PlanId.MAX]: {
    name: "plan.plansMetadata.max.name",
    subtitle: "plan.plansMetadata.max.subtitle",
    isPlanGroup: true,
    featureKey: "plan.plansMetadata.max.featureList",
    badgeProps: {
      color: "green",
      icon: PaperAndPencilIcon,
    },
  },
  [PlanId.FLX]: {
    name: "plan.plansMetadata.flx.name",
    subtitle: "plan.plansMetadata.flx.subtitle",
    isMostPopular: true,
    featureKey: "plan.plansMetadata.flx.featureList",
    badgeProps: {
      color: "purple",
      icon: PaperAndPencilIcon,
    },
  },
  [PlanId.MCI]: {
    name: "plan.maxPlansMetadata.mci.name",
    afterPriceTitle: "plan.maxPlansMetadata.mci.afterPriceTitle",
    mainFeatureKey: "plan.maxPlansMetadata.mci.mainFeatureList",
    badgeProps: {
      color: "green",
      icon: HouseIcon,
    },
  },
  [PlanId.MBI]: {
    name: "plan.maxPlansMetadata.mbi.name",
    afterPriceTitle: "plan.maxPlansMetadata.mbi.afterPriceTitle",
    mainFeatureKey: "plan.maxPlansMetadata.mbi.mainFeatureList",
    badgeProps: {
      color: "red",
      icon: ReceiptIcon,
    },
  },
  [PlanId.EST]: {
    name: "plan.plansMetadata.est.name",
    subtitle: "plan.plansMetadata.est.subtitle",
    afterPriceTitle: "",
    featureKey: "plan.plansMetadata.est.featureList",
    badgeProps: {
      color: "red",
      icon: ReceiptIcon,
    },
  },
  [PlanId.PLN]: {
    name: "plan.plansMetadata.pln.name",
    subtitle: "plan.plansMetadata.pln.subtitle",
    afterPriceTitle: "",
    featureKey: "plan.plansMetadata.pln.featureList",
    badgeProps: {
      color: "red",
      icon: ReceiptIcon,
    },
  },
  [PlanId.USR]: {
    name: "plan.plansMetadata.usr.name",
    subtitle: "plan.plansMetadata.usr.subtitle",
    badgeProps: {
      icon: PaperAndPencilIcon,
    },
  },
  [PlanId.SMR]: {
    name: "plan.plansMetadata.smr.name",
    subtitle: "plan.plansMetadata.smr.subtitle",
    badgeProps: {
      icon: PaperAndPencilIcon,
    },
  },
  [PlanId.DEF]: {
    name: "plan.plansMetadata.def.name",
    subtitle: "plan.plansMetadata.def.subtitle",
    badgeProps: {
      icon: PaperAndPencilIcon,
    },
  },
};

export const defaultPlansMetadata: Partial<Record<PlanId, IPlanListItem>> = {
  [PlanId.FRE]: plansMetadata[PlanId.FRE],
  [PlanId.FLX]: plansMetadata[PlanId.FLX],
  [PlanId.MAX]: plansMetadata[PlanId.MAX],
  [PlanId.EST]: plansMetadata[PlanId.EST],
  [PlanId.PLN]: plansMetadata[PlanId.PLN],
};

export const maxPlansMetadata: Partial<Record<PlanId, IPlanListItem>> = {
  [PlanId.MCI]: plansMetadata[PlanId.MCI],
  [PlanId.MBI]: plansMetadata[PlanId.MBI],
  [PlanId.MAX]: {
    name: "plan.maxPlansMetadata.max.name",
    afterPriceTitle: "plan.maxPlansMetadata.max.afterPriceTitle",
    mainFeatureKey: "plan.maxPlansMetadata.max.mainFeatureList",
    badgeProps: {
      color: "purple",
      icon: StarIcon,
    },
  },
};

export const LT_MAX_PLANS = new Set([PlanId.MAX, PlanId.MBI, PlanId.MCI]);
